class $7cd56f46768996e5$export$f6f0c3fe4ec306ea {
    #cellElement;
    #x;
    #y;
    #tile;
    #mergeTile;
    constructor(cellElement, x, y){
        this.#cellElement = cellElement;
        this.#x = x;
        this.#y = y;
    }
    get x() {
        return this.#x;
    }
    get y() {
        return this.#y;
    }
    get tile() {
        return this.#tile;
    }
    set tile(value) {
        this.#tile = value;
        if (value == null) return;
        this.#tile.x = this.#x;
        this.#tile.y = this.#y;
    }
    get mergeTile() {
        return this.#mergeTile;
    }
    set mergeTile(value) {
        this.#mergeTile = value;
        if (value == null) return;
        this.#mergeTile.x = this.#x;
        this.#mergeTile.y = this.#y;
    }
    canAccept(tile) {
        return this.tile == null || this.mergeTile == null && this.tile.value === tile.value;
    }
    mergeTiles() {
        if (this.tile == null || this.mergeTile == null) return;
        this.tile.value = this.tile.value + this.mergeTile.value;
        this.mergeTile.remove();
        this.mergeTile = null;
        return this.tile.value;
    }
}



class $5bd8f317a28a951e$export$235cb65c20ad2b7 {
    #tileElement;
    #x;
    #y;
    #value;
    constructor(tileContainer, value = Math.random() > 0.1 ? 2 : 4){
        this.#tileElement = document.createElement("div");
        this.#tileElement.classList.add("game__tile");
        tileContainer.append(this.#tileElement);
        this.value = value;
    }
    get value() {
        return this.#value;
    }
    set value(v) {
        this.#value = v;
        this.#tileElement.textContent = v;
        this.#tileElement.className = `game__tile game__tile--${v}`;
    }
    get x() {
        return this.#x;
    }
    set x(value) {
        this.#x = value;
        this.#tileElement.style.setProperty("--x", value);
    }
    get y() {
        return this.#y;
    }
    set y(value) {
        this.#y = value;
        this.#tileElement.style.setProperty("--y", value);
    }
    remove() {
        this.#tileElement.remove();
    }
    waitForTransition(animation = false) {
        return new Promise((resolve)=>{
            this.#tileElement.addEventListener(animation ? "animationend" : "transitionend", resolve, {
                once: true
            });
        });
    }
}


class $7810df3db0975edd$export$ef2184bd89960b14 {
    #cells;
    #gridElement;
    constructor(gridElement, initialGridState = null){
        this.#gridElement = gridElement;
        gridElement.style.setProperty("--grid-size", (0, $852414dda2b7b132$export$bc90872e265d166e));
        this.#cells = this.#createCellElements(gridElement).map((cellElement, index)=>{
            return new (0, $7cd56f46768996e5$export$f6f0c3fe4ec306ea)(cellElement, index % (0, $852414dda2b7b132$export$bc90872e265d166e), Math.floor(index / (0, $852414dda2b7b132$export$bc90872e265d166e)));
        });
        if (initialGridState) this.#populateInitialState(initialGridState);
    }
    get gridElement() {
        return this.#gridElement;
    }
    get cells() {
        return this.#cells;
    }
    get cellsByRow() {
        return this.#cells.reduce((cellGrid, cell)=>{
            cellGrid[cell.y] = cellGrid[cell.y] || [];
            cellGrid[cell.y][cell.x] = cell;
            return cellGrid;
        }, []);
    }
    get cellsByColumn() {
        return this.#cells.reduce((cellGrid, cell)=>{
            cellGrid[cell.x] = cellGrid[cell.x] || [];
            cellGrid[cell.x][cell.y] = cell;
            return cellGrid;
        }, []);
    }
    get #emptyCells() {
        return this.#cells.filter((cell)=>cell.tile == null);
    }
    randomEmptyCell() {
        const randomIndex = Math.floor(Math.random() * this.#emptyCells.length);
        return this.#emptyCells[randomIndex];
    }
    spawnTile() {
        const cell = this.randomEmptyCell();
        if (!cell) return;
        const tile = new (0, $5bd8f317a28a951e$export$235cb65c20ad2b7)(this.gridElement);
        cell.tile = tile;
        return tile;
    }
    clear() {
        this.#cells.forEach((cell)=>{
            if (cell.tile) {
                cell.tile.remove();
                cell.tile = null;
            }
            if (cell.mergeTile) {
                cell.mergeTile.remove();
                cell.mergeTile = null;
            }
        });
    }
    #createCellElements(gridElement) {
        const cells = [];
        for(let i = 0; i < (0, $852414dda2b7b132$export$bc90872e265d166e) * (0, $852414dda2b7b132$export$bc90872e265d166e); i++){
            const cell = document.createElement("div");
            cell.classList.add("game__cell");
            cells.push(cell);
            gridElement.append(cell);
        }
        return cells;
    }
    #populateInitialState(initialState) {
        for(let y = 0; y < initialState.length; y++)for(let x = 0; x < initialState[y].length; x++){
            const value = initialState[y][x];
            if (value) {
                const cell = this.#cells.find((c)=>c.x === x && c.y === y);
                const tile = new (0, $5bd8f317a28a951e$export$235cb65c20ad2b7)(this.#gridElement, value);
                cell.tile = tile;
            }
        }
    }
}


const $852414dda2b7b132$export$bc90872e265d166e = 4;
class $852414dda2b7b132$export$985739bfa5723e08 {
    #grid;
    #status;
    #score;
    static GAME_STATUS = {
        idle: "idle",
        playing: "playing",
        win: "win",
        lose: "lose"
    };
    static DIRECTIONS = {
        UP: "up",
        DOWN: "down",
        LEFT: "left",
        RIGHT: "right"
    };
    constructor(gridElement, initialGridState = null){
        this.#grid = new (0, $7810df3db0975edd$export$ef2184bd89960b14)(gridElement, initialGridState);
        this.#status = $852414dda2b7b132$export$985739bfa5723e08.GAME_STATUS.idle;
        this.#score = 0;
    }
    get grid() {
        return this.#grid;
    }
    get score() {
        return this.#score;
    }
    get status() {
        return this.#status;
    }
    get isGameOver() {
        return this.#status === $852414dda2b7b132$export$985739bfa5723e08.GAME_STATUS.lose;
    }
    get isWin() {
        return this.#status === $852414dda2b7b132$export$985739bfa5723e08.GAME_STATUS.win;
    }
    start() {
        this.#status = $852414dda2b7b132$export$985739bfa5723e08.GAME_STATUS.playing;
        this.spawnTiles(2);
    }
    restart() {
        this.#grid.clear();
        this.#status = $852414dda2b7b132$export$985739bfa5723e08.GAME_STATUS.idle;
        this.#score = 0;
    }
    async tryMove(direction) {
        if (this.#status !== $852414dda2b7b132$export$985739bfa5723e08.GAME_STATUS.playing) return;
        const { UP: UP, DOWN: DOWN, LEFT: LEFT, RIGHT: RIGHT } = $852414dda2b7b132$export$985739bfa5723e08.DIRECTIONS;
        const moveMap = {
            [UP]: [
                this.canMoveUp,
                this.moveUp
            ],
            [DOWN]: [
                this.canMoveDown,
                this.moveDown
            ],
            [LEFT]: [
                this.canMoveLeft,
                this.moveLeft
            ],
            [RIGHT]: [
                this.canMoveRight,
                this.moveRight
            ]
        };
        const [canMove, move] = moveMap[direction] || [];
        if (!canMove?.call(this)) return false;
        await move.call(this);
        this.mergeTiles();
        const [newTile] = this.spawnTiles(1);
        if (!this.canMoveUp() && !this.canMoveDown() && !this.canMoveLeft() && !this.canMoveRight()) {
            this.#status = $852414dda2b7b132$export$985739bfa5723e08.GAME_STATUS.lose;
            if (newTile) await newTile.waitForTransition(true);
        }
        return true;
    }
    canMoveUp() {
        return this.#canMove(this.#grid.cellsByColumn);
    }
    canMoveDown() {
        return this.#canMove(this.#grid.cellsByColumn.map((column)=>[
                ...column
            ].reverse()));
    }
    canMoveLeft() {
        return this.#canMove(this.#grid.cellsByRow);
    }
    canMoveRight() {
        return this.#canMove(this.#grid.cellsByRow.map((row)=>[
                ...row
            ].reverse()));
    }
    moveUp() {
        return this.#slideTiles(this.#grid.cellsByColumn);
    }
    moveDown() {
        return this.#slideTiles(this.#grid.cellsByColumn.map((column)=>[
                ...column
            ].reverse()));
    }
    moveLeft() {
        return this.#slideTiles(this.#grid.cellsByRow);
    }
    moveRight() {
        return this.#slideTiles(this.#grid.cellsByRow.map((row)=>[
                ...row
            ].reverse()));
    }
    #canMove(cells) {
        return cells.some((group)=>{
            return group.some((cell, index)=>{
                if (index === 0) return false;
                if (cell.tile == null) return false;
                const moveToCell = group[index - 1];
                return moveToCell.canAccept(cell.tile);
            });
        });
    }
    #slideTiles(cells) {
        return Promise.all(cells.flatMap((group)=>{
            const promises = [];
            for(let i = 1; i < group.length; i++){
                const cell = group[i];
                if (cell.tile == null) continue;
                let lastValidCell;
                for(let j = i - 1; j >= 0; j--){
                    const moveToCell = group[j];
                    if (!moveToCell.canAccept(cell.tile)) break;
                    lastValidCell = moveToCell;
                }
                if (lastValidCell != null) {
                    promises.push(cell.tile.waitForTransition());
                    if (lastValidCell.tile != null) lastValidCell.mergeTile = cell.tile;
                    else lastValidCell.tile = cell.tile;
                    cell.tile = null;
                }
            }
            return promises;
        }));
    }
    mergeTiles() {
        let scoreGained = 0;
        this.#grid.cells.forEach((cell)=>{
            const mergedValue = cell.mergeTiles();
            if (mergedValue) {
                scoreGained += mergedValue;
                if (mergedValue === 2048) this.#status = $852414dda2b7b132$export$985739bfa5723e08.GAME_STATUS.win;
            }
        });
        this.#score += scoreGained;
    }
    spawnTiles(count = 1) {
        const tiles = [];
        for(let i = 0; i < count; i++){
            const spawnedTile = this.#grid.spawnTile();
            tiles.push(spawnedTile);
        }
        return tiles;
    }
}


const $09e991522ca7e64e$var$gameField = document.querySelector(".game__field");
const $09e991522ca7e64e$var$button = document.querySelector(".button");
const $09e991522ca7e64e$var$gameScore = document.querySelector(".game__score");
const $09e991522ca7e64e$var$loseMessage = document.querySelector(".message--lose");
const $09e991522ca7e64e$var$winMessage = document.querySelector(".message--win");
const $09e991522ca7e64e$var$startMessage = document.querySelector(".message--start");
const $09e991522ca7e64e$var$game = new (0, $852414dda2b7b132$export$985739bfa5723e08)($09e991522ca7e64e$var$gameField);
const { DIRECTIONS: $09e991522ca7e64e$var$DIRECTIONS } = (0, $852414dda2b7b132$export$985739bfa5723e08);
let $09e991522ca7e64e$var$touchStartX = null;
let $09e991522ca7e64e$var$touchStartY = null;
const $09e991522ca7e64e$var$SWIPE_THRESHOLD = 30;
$09e991522ca7e64e$var$button.addEventListener("click", $09e991522ca7e64e$var$handleButtonClick);
function $09e991522ca7e64e$var$handleButtonClick() {
    if ($09e991522ca7e64e$var$game.status === (0, $852414dda2b7b132$export$985739bfa5723e08).GAME_STATUS.idle) $09e991522ca7e64e$var$startGame();
    else $09e991522ca7e64e$var$restartGame();
}
function $09e991522ca7e64e$var$handleTouchStart(e) {
    e.preventDefault();
    const touch = e.changedTouches[0];
    $09e991522ca7e64e$var$touchStartX = touch.clientX;
    $09e991522ca7e64e$var$touchStartY = touch.clientY;
}
async function $09e991522ca7e64e$var$handleTouchEnd(e) {
    e.preventDefault();
    const touch = e.changedTouches[0];
    const dx = touch.clientX - $09e991522ca7e64e$var$touchStartX;
    const dy = touch.clientY - $09e991522ca7e64e$var$touchStartY;
    if (Math.abs(dx) < $09e991522ca7e64e$var$SWIPE_THRESHOLD && Math.abs(dy) < $09e991522ca7e64e$var$SWIPE_THRESHOLD) return;
    let direction;
    if (Math.abs(dx) > Math.abs(dy)) direction = dx > 0 ? $09e991522ca7e64e$var$DIRECTIONS.RIGHT : $09e991522ca7e64e$var$DIRECTIONS.LEFT;
    else direction = dy > 0 ? $09e991522ca7e64e$var$DIRECTIONS.DOWN : $09e991522ca7e64e$var$DIRECTIONS.UP;
    await $09e991522ca7e64e$var$processMove(direction);
}
async function $09e991522ca7e64e$var$processMove(direction) {
    const moved = await $09e991522ca7e64e$var$game.tryMove(direction);
    if (moved) {
        $09e991522ca7e64e$var$updateScore();
        if ($09e991522ca7e64e$var$game.isWin) {
            $09e991522ca7e64e$var$winMessage.classList.remove("hidden");
            $09e991522ca7e64e$var$removeTouchListeners();
            return;
        }
        if ($09e991522ca7e64e$var$game.isGameOver) {
            $09e991522ca7e64e$var$loseMessage.classList.remove("hidden");
            $09e991522ca7e64e$var$removeTouchListeners();
            return;
        }
    }
    $09e991522ca7e64e$var$setupInput();
}
async function $09e991522ca7e64e$var$handleKeyDown(e) {
    const direction = {
        ArrowUp: $09e991522ca7e64e$var$DIRECTIONS.UP,
        ArrowDown: $09e991522ca7e64e$var$DIRECTIONS.DOWN,
        ArrowLeft: $09e991522ca7e64e$var$DIRECTIONS.LEFT,
        ArrowRight: $09e991522ca7e64e$var$DIRECTIONS.RIGHT
    }[e.key];
    if (!direction) {
        $09e991522ca7e64e$var$setupInput();
        return;
    }
    await $09e991522ca7e64e$var$processMove(direction);
}
function $09e991522ca7e64e$var$setupInput() {
    window.addEventListener("keydown", $09e991522ca7e64e$var$handleKeyDown, {
        once: true
    });
}
function $09e991522ca7e64e$var$updateScore() {
    $09e991522ca7e64e$var$gameScore.textContent = $09e991522ca7e64e$var$game.score;
}
function $09e991522ca7e64e$var$startGame() {
    $09e991522ca7e64e$var$button.classList.remove("button--start");
    $09e991522ca7e64e$var$button.classList.add("button--restart");
    $09e991522ca7e64e$var$button.textContent = "Restart";
    $09e991522ca7e64e$var$startMessage.classList.add("hidden");
    $09e991522ca7e64e$var$game.start();
    $09e991522ca7e64e$var$setupInput();
    $09e991522ca7e64e$var$gameField.addEventListener("touchstart", $09e991522ca7e64e$var$handleTouchStart);
    $09e991522ca7e64e$var$gameField.addEventListener("touchend", $09e991522ca7e64e$var$handleTouchEnd);
}
function $09e991522ca7e64e$var$restartGame() {
    $09e991522ca7e64e$var$winMessage.classList.add("hidden");
    $09e991522ca7e64e$var$loseMessage.classList.add("hidden");
    $09e991522ca7e64e$var$startMessage.classList.remove("hidden");
    $09e991522ca7e64e$var$button.classList.remove("button--restart");
    $09e991522ca7e64e$var$button.classList.add("button--start");
    $09e991522ca7e64e$var$button.textContent = "Start";
    $09e991522ca7e64e$var$game.restart();
    $09e991522ca7e64e$var$updateScore();
    $09e991522ca7e64e$var$removeTouchListeners();
}
function $09e991522ca7e64e$var$removeTouchListeners() {
    $09e991522ca7e64e$var$gameField.removeEventListener("touchstart", $09e991522ca7e64e$var$handleTouchStart);
    $09e991522ca7e64e$var$gameField.removeEventListener("touchend", $09e991522ca7e64e$var$handleTouchEnd);
}


//# sourceMappingURL=index.c1bf8dcb.js.map
